import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormHelperText from "@mui/material/FormHelperText";
import { Controller } from "react-hook-form";
import { styles } from "./radioButtonStyle";

const RowRadioButtonsGroup = ({
  label, // Input Label
  name, // Input name
  control, // react-hook-form's control object
  defaultValue, // Default value for the radio group
  options, // List of radio button options
  error, // Boolean indicating error state
  helperText, // Text to display when there's an error
  ...props // Additional props
}) => {
  return (
    <FormControl
      sx={styles.formControl}
      error={error} // Pass error state to MUI's FormControl
      {...props}
    >
      {/* Label for the radio group */}
      <FormLabel id={label} className="text-sm" sx={styles.formLabel}>
        {label}
      </FormLabel>

      {/* Controlled Radio Group using react-hook-form */}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <RadioGroup
            {...field}
            row
            aria-labelledby={label}
            sx={styles.radioGroup}
          >
            {/* Map through options to render radio buttons */}
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio sx={styles.radio} />}
                label={option.label}
                sx={styles.formControlLabel}
                slotProps={{
                  typography: {
                    sx: {
                      fontSize: "14px",
                      gap: "10px",
                    }
                  }
                }}
              />
            ))}
          </RadioGroup>
        )}
      />

      {/* Display helper text when there's an error */}
      {error && (
        <FormHelperText sx={styles.helperText}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default RowRadioButtonsGroup;
